'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POPUP_ARROW_WIDTH = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./PopupArrow.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POPUP_ARROW_WIDTH = exports.POPUP_ARROW_WIDTH = 14;

var PopupArrow = function PopupArrow(_ref) {
    var style = _ref.style;
    return _react2.default.createElement(
        'div',
        { className: 'PopupArrow', style: style },
        _react2.default.createElement('span', { className: 'arrow-outer' }),
        _react2.default.createElement('span', { className: 'arrow-inner' })
    );
};

PopupArrow.propTypes = {
    style: _propTypes2.default.object
};

exports.default = PopupArrow;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/PopupArrow.js
// module id = 1924
// module chunks = 0